import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { useState } from "react";
import { DeleteModal } from "../../components";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useAuth } from "../../store/useAuth";
import { useOnboardings } from "../../store/useOnboardings";

dayjs.extend(relativeTime);

export const OnboardingTable = () => {
  /** Hooks */
  const { allOnboardings, deleteOnboarding } = useOnboardings();
  const navigate = useNavigate();
  const { user } = useAuth();
  /** State */
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Title
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Page
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Date
            </th>
            {user?.user_role === 1 || user?.user_role === 7 ? (
              <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
                Actions
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {allOnboardings?.map((item) => {
            return (
              <tr
                key={item._id}
                className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
              >
                <td
                  onClick={
                    user?.user_role === 1 || user?.user_role === 7
                      ? () => navigate(`/edit-onboarding/${item?._id}`)
                      : undefined
                  }
                  className="px-2 sm:px-6 py-1 sm:py-4 break-all sm:whitespace-nowrap"
                >
                  {item?.title}
                </td>
                <td
                  onClick={
                    user?.user_role === 1
                      ? () => navigate(`/edit-onboarding/${item?._id}`)
                      : undefined
                  }
                  className="px-2 sm:px-6 py-1 sm:py-4"
                >
                  {item?.page}
                </td>
                <td
                  onClick={
                    user?.user_role === 1
                      ? () => navigate(`/edit-onboarding/${item?._id}`)
                      : undefined
                  }
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {dayjs(item?.createdAt).fromNow()}
                </td>
                {user?.user_role === 1 || user?.user_role === 7 ? (
                  <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                    <EditIcon
                      onClick={() => navigate(`/edit-onboarding/${item?._id}`)}
                      className="mr-3 sm:mr-7"
                    />
                    <TrashIcon
                      onClick={() => {
                        const confirmDelete = window.confirm(
                          "Are you sure you want to delete this Onboarding?"
                        );
                        if (confirmDelete) {
                          deleteOnboarding(item._id as string);
                        }
                      }}
                    />
                  </td>
                ) : null}
              </tr>
            );
          })}
        </tbody>
      </table>
      <DeleteModal isOpen={isOpen} closeModal={toggleModal} />
    </div>
  );
};
